export class PagesRoutes {
  public static ROUTES = {
    Pages: {
      path: '',
      fullPath: '',
    },
    Home: {
      path: '/home',
      fullPath: '/home',
    },
    Policies: {
      path: 'policies',
      fullPath: 'policies',
    },
    HelpDesk: {
      path: 'help-desk',
      fullPath: 'help-desk',
    },
    PolicyDetails: {
      path: 'policy-details/:id',
      fullPath: 'policy-details',
    },
    Flow: {
      Massive: {
        path: 'flow/massive',
        fullPath: 'flow/massive',
      },
      Traditional: {
        path: 'flow/traditional',
        fullPath: 'flow/traditional',
        Steps: {
          StepMainData: {
            code: 'FMD',
            path: 'flow/traditional/steps/main-data',
            fullPath: 'flow/traditional/steps/main-data',
            index: 0,
            isComplete: false,
            img: '/assets/img/svg/step-1-blue.svg',
          },
          StepPremisesData: {
            code: 'FPD',
            path: 'flow/traditional/steps/premises-data',
            fullPath: 'flow/traditional/steps/premises-data',
            index: 1,
            isComplete: false,
            img: '/assets/img/svg/step-2-blue.svg',
          },
          StepPricing: {
            code: 'FTP',
            path: 'flow/traditional/steps/pricing',
            fullPath: 'flow/traditional/steps/pricing',
            index: 2,
            isComplete: false,
            img: '/assets/img/svg/step-3-blue.svg',
          },
          StepEndQuote: {
            code: 'SEQ',
            path: 'flow/traditional/steps/end-quote',
            fullPath: 'flow/traditional/steps/end-quote',
            index: 3,
          },
          // StepCheckout: {
          //   code: 'STC',
          //   path: 'steps/checkout',
          //   fullPath: 'quote/steps/checkout',
          //   index: 3,
          //   isComplete: false,
          //   img: '/assets/img/svg/step-4-blue.svg',
          // },
          // StepEndQuote: {
          //   code: 'SEQ',
          //   path: 'steps/end-quote',
          //   fullPath: 'quote/steps/end-quote',
          //   index: 4,
          // },
        },
      },
    },
    Engineering: {
      Policies: {
        path: 'engineering/policy-list',
        fullPath: 'engineering/policy-list',
      },
      HelpDesk: {
        path: 'engineering/proposals-list',
        fullPath: 'engineering/proposals-list',
      },
      Flow: {
        path: 'engineering/flow',
        fullPath: 'engineering/flow',
        Steps: {
          StepMainData: {
            code: 'FMD',
            path: 'engineering/flow/steps/main-data',
            fullPath: 'engineering/flow/steps/main-data',
            index: 0,
            isComplete: false,
            img: '/assets/img/svg/step-1-blue.svg',
          },
          StepPremisesData: {
            code: 'FPD',
            path: 'engineering/flow/steps/premises-data',
            fullPath: 'engineering/flow/steps/premises-data',
            index: 1,
            isComplete: false,
            img: '/assets/img/svg/step-2-blue.svg',
          },
          StepPricing: {
            code: 'FTP',
            path: 'engineering/flow/steps/pricing',
            fullPath: 'engineering/flow/steps/pricing',
            index: 2,
            isComplete: false,
            img: '/assets/img/svg/step-3-blue.svg',
          },
          StepEndQuote: {
            code: 'SEQ',
            path: 'engineering/flow/steps/end-quote',
            fullPath: 'engineering/flow/steps/end-quote',
            index: 3,
          },
        },
      },
    },
  };
}
